import { removeFromCart } from './cart';

const setupRemoveOnClicks = () => {
  const btns = document.querySelectorAll('.lg-cart-rm-btn');
  btns.forEach((btn) => {
    btn.onclick = (e) => {
      const code = e.target.getAttribute('data-code');
      removeFromCart(code)
        .then(() => { window.location.reload(); })
        .catch(console.error);
    };
  });
};

const init = () => {
  setupRemoveOnClicks();
};

init();
